export const BACKEND_URL = "https://controlvehsamconet-gkajcga3hkdtfsdy.westus-01.azurewebsites.net/api";
//export const BACKEND_URL = "https://controlvehsamconet-gkajcga3hkdtfsdy.westus-01.azurewebsites.net/api";
